export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10028.a2bc02dd.jpg";